<!-- <p>badminton-tournament works!</p> -->

<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Chess Championship</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Nagpur District Open and Women's <span>Chess Championship 2025 </span></h2>
        </div>

        <div class="row text-justify">
            <div class="col-lg-12">
                <p>
                    Nagpur, January 12, 2025 – Nagpur District Open and Women's Chess Championship 2025, organized by Chess Association Nagpur in association with G.H. Raisoni Sports and Cultural Foundation and Kalpana Prakash Welfare
                    Foundation, concluded successfully at Vivekanand Hall, Shraddha House, Kingsway, Near Kasturchand Park, Nagpur.
                </p>
                <p><strong>Champions Crowned</strong></p>
                <p>In a thrilling competition, Sai Sharma emerged victorious in the Open Group, scoring 6.5 out of 7 to claim the title. In the Women&#39;s Group, Shraddha Bajaj dominated with 6.5 points, securing her championship win.</p>
            </div>

            <div class="border-line-sm"></div>
            <div class="col-lg-12">
                <div class="widget_title inner-title mt-3">
                    <h4>Top Performers in Open Group</h4>
                </div>
                <ul class="list-style list-style1">
                    <li><strong>2nd - 7th Place</strong>: Mayank Hedau, Yugant Ramteke, Chandrasekhar Sable, Sumedh Ramteke, Apratim Yadav, and Deep Juare (all scoring 5.5 points, ranked based on tie-break scores).</li>
                    <li><strong>Veteran Prize</strong>:Shri H.K. Khan.</li>
                    <li><strong>Consolation Prize</strong>:Hemantkumar Devangan.</li>
                </ul>
            </div>
            <div class="border-line-sm"></div>
            <div class="col-lg-12">
                <div class="widget_title inner-title mt-3">
                    <h4>Top Performers in Women's Group</h4>
                </div>
                <ul class="list-style list-style1">
                    <li><strong> 2nd Place</strong>: Lakshita Rathod (5.5 points).</li>
                    <li><strong> 3rd Place</strong>: Divyanshi Khandelwal (5.5 points).</li>
                    <li><strong> 4th - 8th Place</strong>: Vritika Game, Anvi Hirde, Swara Gandhi, Tanishka Bhardwaj, and Bhakti Titarmare (all scoring 5 points, ranked based on tie-break scores).</li>
                    <li><strong> Veteran Prize:</strong>: Smt. Asha Rai (70 years old).</li>
                </ul>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="sec-title text-center">
            <h2>Cash Prizes Introduced</h2>
        </div>
        <p>This year, the Nagpur District Selection Chess Championship introduced cash prizes, sponsored by MHK Sancheti Group:</p>

        <div class="col-lg-12">
            <div class="col-lg-6">
                <div class="widget_title inner-title mt-3">
                    <h4>Top Performers in Women's Group</h4>
                </div>
                <ul class="list-style list-style1">
                    <li><strong>Sai Sharma (Open Group Winner)</strong>: ₹2,000</li>
                    <li><strong>Shraddha Bajaj (Women's Group Winner)</strong>: ₹2,000</li>
                </ul>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="sec-title text-center">
            <h2>State Championship Selection</h2>
        </div>
        <p>The top four players from each category have been selected to represent Nagpur district in the upcoming Maharashtra State Open and Women's Chess Championship:</p>

        <div class="col-lg-12">
            <ul class="list-style list-style1">
                <li><strong>Open Group: </strong>: Sai Sharma, Mayank Hedau, Yugant Ramteke, Chandrasekhar Sable.</li>
                <li><strong>Women's Group:</strong>: Shraddha Bajaj, Lakshita Rathod, Divyanshi Khandelwal, Vritika Game.</li>
            </ul>
        </div>
        <div class="border-line-sm"></div>
        <div class="sec-title text-center">
            <h2>Prize Distribution Ceremony</h2>
        </div>
        <p>The prize distribution ceremony was graced by:</p>

        <div class="col-lg-12">
            <ul class="list-style list-style1">
                <li><strong>Chief Guest: </strong>: Shri Amit Yenurkar, Director, MHK Sancheti Group (Cash Prize Sponsor).</li>
                <li><strong>Guest of Honour:</strong>: CA Saket Bagadia, Ex-President, ICAI Nagpur.</li>
                <li><strong>Officials Present:</strong>: Shri Bhushan Shriwas (Secretary, Chess Association Nagpur & Kalpana Prakash Welfare Foundation), Chief Arbiter SNA Shyam Agrawal.</li>
            </ul>
        </div>
        <div class="border-line-sm"></div>
        <div class="sec-title text-center">
            <h2>Awards & Recognition</h2>
        </div>

        <div class="col-lg-12">
            <ul class="list-style list-style1">
                <li><strong>Top 10 finishers (Open & Women)</strong>: Cash prizes sponsored by MHK Sancheti Group.</li>
                <li><strong>Top 4 finishers (Open & Women):</strong>: Trophies.</li>
                <li><strong>Under-15, 13, 11, 9, and 7 age categories:</strong>: Medals for the top two finishers.</li>
            </ul>
        </div>
        <div class="border-line-sm"></div>
        <div class="sec-title text-center">
            <h2>Arbitration Team</h2>
        </div>

        <div class="col-lg-12">
            <ul class="list-style list-style1">
                <li><strong>Chief Arbiter</strong>: SNA Shyam Agrawal.</li>
                <li><strong>Assistant Arbiters</strong>: FA Bharti Dhote, SNA Prayas Ambade, SNA Akash Rewatkar, Prathamesh Machave.</li>
                <li><strong>Under-15, 13, 11, 9, and 7 age categories:</strong>: Medals for the top two finishers.</li>
            </ul>
            <p>The event was successfully conducted by Shri S.S. Soman, ensuring smooth execution and a competitive spirit throughout.</p>
        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-1.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-2.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
